import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

const Container = styled('div')`
  bottom: 0;
  box-shadow: ${props => props.hover ? '0 3px 8px 0 rgba(0, 0, 0, 0.15)' : '0 2px 5px 0 rgba(0, 0, 0, 0.1)'};
  height: 50%;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  transition: .15s box-shadow;
  width: 95%;
  z-index: 0;
`;

function Shadow(props) {
  return (
    <Container hover={props.hover} />
  );
}

Shadow.propTypes = {
  hover: PropTypes.bool,
};

Shadow.defaultProps = {
  hover: false,
};

export default Shadow;



// WEBPACK FOOTER //
// ./src/components/Shadow/Shadow.js